import { isMaleGender } from 'helpers/utils';

import { ICardDataStartAge, IGender } from 'types/commonInterfaces';

const MALE_MODEL_IMAGE = 'maleModelImage';
const FEMALE_MODEL_IMAGE = 'femaleModelImage';
const MALE_AGE_RANGE = 'maleAgeRange';
const FEMALE_AGE_RANGE = 'femaleAgeRange';

export const getContent = (
    gender: IGender,
    config: Record<string, string | undefined> = {}
): { cards: ICardDataStartAge[]; titleData: { key: string; values: Record<string, string> } } => {
    const cardKeys = [1, 2, 3, 4];
    const isMale = isMaleGender(gender);

    const cards = cardKeys.map((cardKey) => {
        return {
            img: (isMale ? config[`${MALE_MODEL_IMAGE}${cardKey}`] : config[`${FEMALE_MODEL_IMAGE}${cardKey}`]) ?? '',
            title: (isMale ? config[`${MALE_AGE_RANGE}${cardKey}`] : config[`${FEMALE_AGE_RANGE}${cardKey}`]) ?? '',
        };
    });

    // TODO: some refactoring later
    const titlesWithoutSubtitle = ['refund_lose', 'refund_muscle', 'refund_fit', 'refund_wall', '28_work', '28_wall'];
    const isNewTitle = titlesWithoutSubtitle.includes(config.screenTitle || 'default');

    const key = isNewTitle ? 'startPages.startAgeFullConfA.titleNew' : 'startPages.startAgeFullConfA.title';

    const secondaryTitle = isNewTitle ? config.subtitle || '' : config.subtitle || 'default';

    const titleData = {
        key,
        values: { mainTitle: config.screenTitle || 'default', secondaryTitle },
    };

    return { cards, titleData };
};
